import {createSlice} from '@reduxjs/toolkit';
import {getClients, getDistClients, getClient, changeActive, updateClient, createClient, updateAddress, createAddress, removeAddress, getMontoDistMinimo, updateMinAmountClient} from '../../api/Clients';

export const clientsSlice = createSlice({
  name: 'clients',
  initialState: {
    clients: [],
    distributors: [],
    client: {},
    addresses: [],
    address: {},
    page: 1,
    loaded: false,
    distloaded: false,
  },
  reducers: {
    setClients: (state, action) => {
      state.clients = action.payload;
    },
    setDistClients: (state, action) => {
      state.distributors = action.payload;
    },
    setClient: (state, action) => {
      state.client = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setDistLoaded: (state, action) => {
      state.distloaded = action.payload;
    },
    setLoaded: (state, action) => {
      state.loaded = action.payload;
    },
    setActive: (state, action) => {
      state.client.Status = action.payload;
    },
    setAddress: (state, action) => {
      state.address = action.payload;
    },
    addAddress: (state, action) => {
      state.addresses.push(action.payload);
    }
  },
});

// Action creators are generated for each case reducer function
export const {setClients, setDistClients, setClient, setActive, setPage, setLoaded, setDistLoaded, setAddress, addAddress} = clientsSlice.actions;

export const getAllClients = () => async dispatch => {
  try {
    const response = await getClients();
    if (!response.error && response.status === 200) {
      dispatch(setClients(response.data));
      return {
        status: 'success',
      };
    }
    return {
      status: 'error',
      type: 'unkown'
    };
  } catch (e) {
    return {
      status: 'error',
      type: 'unknown',
    };
  }
};

export const getAllDistClients = () => async dispatch => {
  try {
    const response = await getDistClients();
    if (!response.error && response.status === 200) {
      dispatch(setDistClients(response.data));
      return {
        status: 'success',
      };
    }
    return {
      status: 'error',
      type: 'unkown'
    };
  } catch (e) {
    return {
      status: 'error',
      type: 'unknown',
    };
  }
};

export const activeClient = (id, val) => async dispatch => {
  try {
    dispatch(setActive(!val));
    const response = await changeActive(id);
    if (!response.error && response.status === 200) {
      return {
        status: 'success',
      };
    }
    dispatch(setActive(val));
    return {
      status: 'error',
      type: 'unkown'
    };
  } catch (e) {
    dispatch(setActive(val));
    return {
      status: 'error',
      type: 'unknown',
    };
  }
};

export const getMontoMinimo = client => async dispatch => {
  try {
    const response = await getMontoDistMinimo(client);
    if (!response.error && response.status === 200) {
      return {
        status: 'success',
        info: response.data
      };
    }
    return {
      status: 'error',
      type: 'unkown'
    };
  } catch (e) {
    return {
      status: 'error',
      type: 'unknown',
    };
  }
};

export const getClientDetails = client => async dispatch => {
  try {
    const response = await getClient(client);
    if (!response.error && response.status === 200) {
      dispatch(setClient(response.data));
      return {
        status: 'success',
      };
    }
    return {
      status: 'error',
      type: 'unkown'
    };
  } catch (e) {
    return {
      status: 'error',
      type: 'unknown',
    };
  }
};

export const editClient = (id, data) => async (dispatch) => {
  try {
    const response = await updateClient(id, data);
    if (!response.error && response.status === 200) {
      dispatch(setClient(response.data.customer));
      return {
        status: "success",
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
};

export const setClientMinAmount = (data, id) => async (dispatch) => {
  try {
    const response = await updateMinAmountClient(data, id);
    if (!response.error && response.status === 200) {
      dispatch(setClient(response.data.customer));
      return {
        status: "success",
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
};

export const newClient = (data) => async (dispatch) => {
  try {
    const response = await createClient(data);
    if (!response.error && response.status === 200) {
      dispatch(setClient(response.data));
      return {
        status: "success",
        client: response.data,
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
};

export const editAddress = (id, addr) => async (dispatch) => {
  try {
    const response = await updateAddress(id, addr);
    if (!response.error && response.status === 200) {
      dispatch(setAddress(response.data.customer));
      return {
        status: "success",
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
};

export const newAddress = (data) => async (dispatch) => {
  try {
    const response = await createAddress(data);
    if (!response.error && response.status === 200) {
      dispatch(addAddress(response.data.customer));
      return {
        status: "success",
        client: response.data,
      };
    }
    return {
      status: "error",
      type: "unkown",
    };
  } catch (e) {
    return {
      status: "error",
      type: "unknown",
    };
  }
};

export const selectClients = state => state.clients.clients;
export const selectDistClients = state => state.clients.distributors;
export const selectClient = state => state.clients.client;
export const selectPage = state => state.clients.page;
export const selectLoaded = state => state.clients.loaded;
export const selectDistLoaded = state => state.clients.distloaded;

export default clientsSlice.reducer;
